module.exports = __webpack_public_path__ + "img/10.89401e6f.jpg";